import classnames from 'classnames/bind'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalGridPreset } from '~/@types/grid-preset'
import { GlobalTextPreset } from '~/@types/text-preset'
import { GlobalTextStyling } from '~/@types/text-styling'

import AbstractPagination, {
  PaginationProps as AbstractPaginationProps,
} from '~/components/Abstracts/Pagination'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface PaginationProps extends AbstractPaginationProps {
  className?: string
  hidden?: boolean
}

function Pagination({ className, hidden, ...rest }: PaginationProps) {
  const gridStyle = useStyle({ grid: GlobalGridPreset.BASE_GRID })
  const linkStyle = useStyle({
    textPreset: GlobalTextPreset.Label12Haffer,
    color: GlobalThemeColors.Black,
    textStyling: GlobalTextStyling.UpperCase,
  })

  return (
    <div className={cx(css.Pagination, className, gridStyle, { hidden })}>
      <AbstractPagination
        className={cx(css.content)}
        linkClassName={cx(css.link, linkStyle)}
        activeClassName={cx(css.active)}
        {...rest}
      />
    </div>
  )
}

Pagination.defaultProps = {}

export default Pagination
